import { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, getAll, addItem, updateItem } from '../../../redux/companyQboCustomFields';

export default function useQuickbookCustomField() {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state.companyQboCustomFields);
    const items = selectors.selectAll(reduxState);

    const save = useCallback((item) => {
        const updateCall = async () => {
            console.log('save qbo custom field item', item);
            let response = null;
            if (item.qbo_custom_field_id) {
                response = await dispatch(updateItem({ id: item.qbo_custom_field_id, ...item }));
            } else {
                response = await dispatch(addItem({ ...item }));
            }
            return response;
        };
        return updateCall();
    }, [dispatch]);

    return [
        items,
        save,
    ];
};
